<template>
    <div class="us_app">
        <section class="user_section">
            <div class="title jc">
                <h2>환자 관리</h2>
            </div>
            <article class="view cmnity">
                <div class="search_box" style="flex-wrap: wrap">
                    <p class="w100 mb20">
                        총 환자수
                        <strong> {{ searchInfo.pageInfo.totPage }} </strong>건
                    </p>

                    <div class="flex items-center justify-between w100">
                        <div class="form_inline">
                            <span class="mw100 fwb">환자명</span>
                            <input
                                type="text"
                                class="form_control"
                                placeholder="환자명을 입력하세요."
                                v-model="searchInfo.patient_nm"
                                @keyup.enter="fn_search"
                            />
                            <span class="mw100 fwb">성별</span>
                            <div class="form_radio">
                                <input type="radio" id="radio1" name="radio"  value="" v-model="searchInfo.patient_gender">
                                <label for="radio1">전체</label>
                            </div>  
                            <div class="form_radio">
                                <input type="radio" id="radio2" name="radio"  value="M" v-model="searchInfo.patient_gender">
                                <label for="radio2">남</label>
                            </div>
                            <div class="form_radio">
                                <input type="radio" id="radio3" name="radio" value="F" v-model="searchInfo.patient_gender" >
                                <label for="radio3">여</label>
                            </div>   
                        </div>
                        <div class="form_inline">
                            <button class="btn btn_md btn_darkbrown" @click="fn_search">검색</button>
                            <button
                                class="btn btn_md btn_brown"
                                @click="fn_move_regPage"
                            >
                                내 환자 등록
                            </button>
                        </div>
                    </div>
                    <div class="flex items-center justify-between w100 mt10">
                        <div class="form_inline">
                            <span class="mw100 fwb">차트번호</span>
                            <input
                                type="text"
                                class="form_control"
                                placeholder="차트번호를 입력하세요."
                                v-model="searchInfo.patient_chart_no"
                                @keyup.enter="fn_search"
                            />
                        </div>
                        <div class="form_inline">
                            <input type="file" ref="patientExcelUpload" @change="fn_excel_read" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" hidden/>
                            <button class="btn btn_md btn_outline" @click="fn_excel_upload_click" :disabled="bulkButtonDisabled"><i class="icon icon_excel"></i>Excel 일괄등록</button>
                            <button
                                v-if="failExcelDownBtnShow"
                                type="button"
                                class="btn btn_md btn_outline"
                                @click="fn_download_failed_rows_excel(lastUploadResult.failRows)"
                            >
                                <i class="icon icon_excel"></i>
                                실패목록 다운로드
                            </button>
                          <button class="btn_guide_icon" @click="guideModalShow = true" title="환자 등록 가이드">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <circle cx="12" cy="12" r="10"/>
                                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                                    <line x1="12" y1="17" x2="12.01" y2="17"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="tab_contents">
                    <div class="lay_left">
                        <div class="table_list">
                            <table class="list">
                                <colgroup>
                                    <col width="100">
                                    <col width="100">
                                    <col width="50">
                                    <col width="50">
                                    <col width="120">
                                    <col width="*">
                                    <col width="50">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>차트번호</th>
                                        <th>환자명</th>
                                        <th>성별</th>
                                        <th>나이</th>
                                        <th>전화번호</th>
					                    <th>주소</th>
                                        <th>삭제</th>    
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="patientList.length == 0">
                                        <td colspan="6"><span>데이터가 없습니다.</span></td>
                                    </tr>
                                    <tr v-for="(item, index) in patientList" :key="index" @click="fn_move_dtl_page(item.patient_seq)">
                                    <td><span>{{ item.patient_chart_no}}</span></td>
                                    <td><span>{{ item.patient_nm }}</span></td>
                                    <td><span>{{ item.patient_gender_nm }}</span></td>
                                    <td><span>{{ item.patient_age}}</span></td>
                                    <td><span>{{ formatPhoneNumber(item.patient_tel_num) }}</span></td>
                                    <td><span>{{ item.patient_addr }} {{ item.patient_addr_dtl }}</span></td>
                                    <td><button class="icon icon_del" @click.stop="fn_del_patient(item)" ></button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <Pagination :pageInfo="searchInfo.pageInfo" @clickPage="movePage" v-show="pagingShow"/>
                    </div>
                </div>
            </article>
        </section>
        <alert-modal
            :id="'confirm'"
            :text="alertMsg"
            :btnLeft="'취소'"
            :btnRight="'확인'"
            :oneBtn="true"
            :isShow="comfirmAlertShow"
            :className="'btn_brown'"
            @callback="fn_alert_close"
        />

        <!-- 환자 등록 가이드 모달 -->
        <div v-if="guideModalShow" class="guide_modal_overlay" @click.self="guideModalShow = false">
            <div class="guide_modal_inner">
                <div class="guide_modal_header">
                    <h3>환자 등록 가이드</h3>
                    <button class="btn_close" @click="guideModalShow = false"></button>
                </div>
                <div class="guide_modal_body">
                    <img :src="require('@/assets/img/layout/patient_reg_guide.png')" alt="환자 등록 가이드" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import Pagination from "@/components/AdminPagination.vue"
import { read, utils, writeFile } from 'xlsx'
import AlertModal from "@/modal/common/alertModal.vue"
import alertutill from "@/mixin/alertModalUtill";

export default {
    name: 'PatientList',
    mixins: [commonUtil,alertutill],
    components: {
      Pagination,
      AlertModal
    },
    data() {
        return {
            searchInfo : {
                patient_nm : '',
                clinic_doctor_id : '',
                patient_gender : '',
                patient_chart_no : '',
                pageInfo : {
                    page : 1,
                    pageSize : 10,
                    totPage : 0
                }                
            },
            pagingShow : false,
            patientList: [],
            lastUploadResult : {},
            bulkButtonDisabled : false,
            comfirmAlertShow : false,
            patientDeleteInfo : {},
            alertMsg : '',
            failExcelDownBtnShow : false,
            guideModalShow : false
        }
    },
    created(){
        //this.fn_search();
        this.searchInfo.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
    },
    mounted(){
        this.fn_search();
    },
    methods : {
        fn_search(){
            axios
                .post("/api/user/mypage/getPetientList", this.searchInfo)
                .then((res) => {
                    console.log("@@@@ res : %o",res);
                    this.patientList = res.data.patientList;

                    console.log("@@@@ patientList : %o",this.patientList);

                    this.searchInfo.pageInfo.totPage = res.data.totCnt;
                    
                    if(this.searchInfo.pageInfo.totPage> 0){
                        this.pagingShow = true;                          
                    }                        

                })
                .catch((err) => console.log(err));
        },
        movePage(page){
            console.log("@@@@@ page : "+page);
            this.searchInfo.pageInfo.page = page;
            this.fn_search();
        },
        fn_move_dtl_page(seq){
            this.$store.dispatch('detailSearchInfo/setSearchId', seq); 
            this.$router.push({ name : 'PatientDtl'});
        },
        fn_move_regPage(){
            this.$router.push("/mypage/patientReg");
        },
        fn_excel_upload_click(){

            if(this.bulkButtonDisabled){
                alert("일괄등록중입니다.");
            }else{
                let fileInputElement = this.$refs.patientExcelUpload;
                this.bulkButtonDisabled = true;
                fileInputElement.click();
            }
        },
        async fn_excel_read(event){
            console.log("@@@@@ fn_excel_read ");

            const file = event.target.files && event.target.files[0];
            if (!file) return;

            // 같은 파일 재업로드 가능하게
            event.target.value = '';

            const reader = new FileReader();

            reader.onload = async (e) => {
                const data = e.target.result;
                const workbook = read(data, { type: 'array' });

                const targetSheetName = '환자';
                const sheet = workbook.Sheets[targetSheetName];
                if (!sheet) {
                    alert(`'${targetSheetName}' 시트를 찾을 수 없습니다.`);
                    return;
                }

                // 0행(헤더)은 건너뛰고, 컬럼명을 강제 지정
                const rows = utils.sheet_to_json(sheet, {
                range: 1,
                header: [
                    'patient_chart_no',
                    'patient_nm',
                    'patient_gender',
                    'patient_age',
                    'patient_tel_num',
                    'patient_post_no',
                    'patient_addr',
                    'patient_addr_dtl'
                ],
                defval: '',
                raw: false
                });


                //엑셀 빈행 제거
                const cleaned = rows
                    .map((r, i) => ({
                    ...r,
                    __excelRow: i + 2 // 엑셀 실제 행 번호(헤더 1행 고려)
                    }))
                    .filter(r => Object.values(r).some(v => String(v).trim() !== ''))

                const result = await this.fn_excel_patient_upload_chunked(cleaned)

                // 여기서 UI에 결과 표시/다운로드 등 연결
                console.log('업로드 결과', result)

                this.lastUploadResult = result // data에 저장
                if (result.failCount > 0) {
                    // 자동 다운로드를 원하면 여기서 바로 호출
                    // this.fn_download_failed_rows_excel(result.failRows)

                    // 보통은 사용자에게 버튼으로 선택시키는 게 운영 친화적
                    alert(`성공 ${result.successCount}건 / 실패 ${result.failCount}건 (실패 목록 다운로드 가능)`)
                    this.bulkButtonDisabled = false;
                    this.failExcelDownBtnShow = true;

                }else{
                    alert(`성공 ${result.successCount} 건`);
                    this.bulkButtonDisabled = false;
                }

                this.fn_search();
            };

            reader.readAsArrayBuffer(file);

        },
        async fn_excel_patient_upload_chunked(rows){
                const chunkSize = 500
                const totalChunks = Math.ceil(rows.length / chunkSize)

                const finalResult = {
                total: rows.length,
                successCount: 0,
                failCount: 0,
                successRows: [], // 성공 row 원본
                failRows: []     // 실패 row 원본 + error/reason
                }

                for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
                const start = chunkIndex * chunkSize
                const chunk = rows.slice(start, start + chunkSize)

                let param = new Object();
                param.chunk = chunk;
                param.clinic_doctor_id = this.searchInfo.clinic_doctor_id ;

                try {
                    // 서버는 rowIndex(0-based, chunk 내부 인덱스) 기준으로 failRows 내려줌
                    const res = await axios.post('/api/user/mypage/excelPatientUpload', param, { timeout: 60000 })

                    const failRowsFromServer = (res.data && res.data.failRows) ? res.data.failRows : []
                    const failIndexSet = new Set(failRowsFromServer.map(x => x.rowIndex))

                    // 실패 행 매핑 (실패 사유 포함)
                    for (const fr of failRowsFromServer) {
                    const row = chunk[fr.rowIndex]
                    if (!row) continue
                        finalResult.failRows.push({
                            ...row,
                            error: fr.reason || 'Unknown error',
                            //__chunk: chunkIndex + 1
                        })
                    }

                    // 성공 행 = chunk - 실패행
                    const successInChunk = chunk.filter((_, i) => !failIndexSet.has(i))
                    finalResult.successRows.push(...successInChunk)

                    var successCountFromServer =
                    res && res.data && res.data.successCount != null
                        ? res.data.successCount
                        : successInChunk.length;

                    var failCountFromServer =
                    res && res.data && res.data.failCount != null
                        ? res.data.failCount
                        : failRowsFromServer.length;

                    finalResult.successCount += successCountFromServer;
                    finalResult.failCount += failCountFromServer;
                    

                } catch (e) {
                    // 네트워크/서버 장애 등으로 chunk 자체가 실패한 경우:
                    // 이 경우는 row 단위 구분이 불가능하므로 chunk 전체를 실패로 분류
                    var errMsg = (e && e.message) ? e.message : 'unknown';

                    for (var j = 0; j < chunk.length; j++) {
                    var r = chunk[j];

                    // 객체 spread 대신 Object.assign 사용
                    finalResult.failRows.push(Object.assign({}, r, {
                        error: 'Chunk request failed: ' + errMsg,
                        __chunk: chunkIndex + 1
                    }));
}
                    finalResult.failCount += chunk.length
                }

                // UI 프리징 방지
                await new Promise(r => setTimeout(r, 0))
                }

            return finalResult
        
        },
        fn_download_failed_rows_excel(failedRows) {
            const ws = utils.json_to_sheet(failedRows)
            const wb = utils.book_new()
            utils.book_append_sheet(wb, ws, '실패데이터')
            writeFile(wb, '환자_업로드_실패.xlsx');
            this.failExcelDownBtnShow = false;
            alert("실패 목록이 다운로드 되었습니다.");
        },
        fn_del_patient(item){

            this.patientDeleteInfo.clinic_doctor_id = this.searchInfo.clinic_doctor_id ;
            this.patientDeleteInfo.patient_seq = item.patient_seq ;

            this.alertMsg = item.patient_nm+" 환자를 정말 삭제하시겠습니까?"
            this.comfirmAlertShow = true;
        },
        fn_alert_close(type){
        
        this.comfirmAlertShow = false;
                      
        if(type == 'ok'){

           axios
            .post("/api/user/mypage/deletePatient", this.patientDeleteInfo)
            .then((res) => {
                console.log("@@@@ res : %o",res);
                
                //this.$emit('callback', res.data.patient_seq);
                let msg = "삭제되었습니다.";
                this.fn_open_alert(msg);
                this.fn_search();

            })
            .catch((err) => console.log(err));
        }

      }
    }
}
</script>

<style scoped>
.btn_guide_icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;
    color: #7a5c3a;
    vertical-align: middle;
    border-radius: 50%;
    transition: background 0.15s;
}
.btn_guide_icon:hover {
    background: rgba(122, 92, 58, 0.1);
}
.btn_guide_icon svg {
    width: 22px;
    height: 22px;
}
.guide_modal_overlay {
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}
.guide_modal_inner {
    background: #fff;
    border-radius: 8px;
    max-width: 90vw;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.guide_modal_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #e0e0e0;
}
.guide_modal_header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
}
.guide_modal_header .btn_close {
    width: 28px;
    height: 28px;
    background: none;
    border: none;
    cursor: pointer;
    position: relative;
    flex-shrink: 0;
}
.guide_modal_header .btn_close::before,
.guide_modal_header .btn_close::after {
    content: '';
    position: absolute;
    top: 50%; left: 50%;
    width: 18px;
    height: 2px;
    background: #333;
    border-radius: 1px;
}
.guide_modal_header .btn_close::before { transform: translate(-50%, -50%) rotate(45deg); }
.guide_modal_header .btn_close::after  { transform: translate(-50%, -50%) rotate(-45deg); }
.guide_modal_body {
    overflow: auto;
    padding: 20px;
}
.guide_modal_body img {
    display: block;
    max-width: 100%;
    height: auto;
}
</style>
